import { Icon } from '@iconify/react';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { MONTHS } from '../payroll.api';

export interface YearMonth {
  year: number;
  month: number;
}

export const thisMonth = (): YearMonth => {
  const d = new Date();
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
};

/** The month before the current one — payroll is normally run for a month that has ended. */
export const lastMonth = (): YearMonth => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
};

const shift = ({ year, month }: YearMonth, by: number): YearMonth => {
  const index = year * 12 + (month - 1) + by;
  return { year: Math.floor(index / 12), month: (index % 12) + 1 };
};

/** ‹ Month ▾ Year ▾ › */
export default function MonthPicker({ value, onChange }: { value: YearMonth; onChange: (v: YearMonth) => void }) {
  const current = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => current + 1 - i);
  if (!years.includes(value.year)) years.push(value.year);
  return (
    <Stack direction='row' alignItems='center' gap={1}>
      <IconButton size='small' aria-label='Previous month' onClick={() => onChange(shift(value, -1))}>
        <Icon icon='mdi:chevron-left' />
      </IconButton>
      <TextField
        select
        size='small'
        label='Month'
        value={value.month}
        onChange={(e) => onChange({ ...value, month: Number(e.target.value) })}
        sx={{ minWidth: 140 }}
      >
        {MONTHS.map((m, i) => (
          <MenuItem key={m} value={i + 1}>
            {m}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        size='small'
        label='Year'
        value={value.year}
        onChange={(e) => onChange({ ...value, year: Number(e.target.value) })}
        sx={{ minWidth: 100 }}
      >
        {years.map((y) => (
          <MenuItem key={y} value={y}>
            {y}
          </MenuItem>
        ))}
      </TextField>
      <IconButton size='small' aria-label='Next month' onClick={() => onChange(shift(value, 1))}>
        <Icon icon='mdi:chevron-right' />
      </IconButton>
    </Stack>
  );
}
